/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_No_InvitationInputs */

const th_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีคำเชิญให้ตอบรับ`)
};

const en_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There is no invitation to accept.`)
};

const ja_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`承認できる招待がありません。`)
};

const zh_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有可接受的邀请。`)
};

const es_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay ninguna invitación que aceptar.`)
};

const pt_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não há convite para aceitar.`)
};

const id_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada undangan untuk diterima.`)
};

const fr_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il n’y a aucune invitation à accepter.`)
};

const tl_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang paanyayang matatanggap.`)
};

const vi_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có lời mời nào để nhận.`)
};

const ko_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수락할 초대가 없습니다.`)
};

const de_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es gibt keine Einladung anzunehmen.`)
};

const ru_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принимать нечего — приглашения нет.`)
};

const tr_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kabul edilecek bir davet yok.`)
};

const it_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non c'è nessun invito da accettare.`)
};

const pl_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie ma zaproszenia do przyjęcia.`)
};

const uk_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Немає запрошення, яке можна прийняти.`)
};

const hi_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वीकार करने के लिए कोई निमंत्रण नहीं है।`)
};

const ar_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد دعوة لقبولها.`)
};

const ms_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada jemputan untuk diterima.`)
};

const bn_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`গ্রহণ করার মতো কোনও আমন্ত্রণ নেই।`)
};

const zh_tw2_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有可接受的邀請。`)
};

const zh_hk2_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有可接受的邀請。`)
};

const ur_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قبول کرنے کے لیے کوئی دعوت نہیں۔`)
};

const fa_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعوتی برای پذیرفتن نیست.`)
};

const sw_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna mwaliko wa kukubali.`)
};

const nl_err_no_invitation = /** @type {(inputs: Err_No_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er is geen uitnodiging om aan te nemen.`)
};

/**
* | output |
* | --- |
* | "There is no invitation to accept." |
*
* @param {Err_No_InvitationInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_no_invitation = /** @type {((inputs?: Err_No_InvitationInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_No_InvitationInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_no_invitation(inputs)
	if (locale === "ja") return ja_err_no_invitation(inputs)
	if (locale === "zh") return zh_err_no_invitation(inputs)
	if (locale === "es") return es_err_no_invitation(inputs)
	if (locale === "pt") return pt_err_no_invitation(inputs)
	if (locale === "id") return id_err_no_invitation(inputs)
	if (locale === "fr") return fr_err_no_invitation(inputs)
	if (locale === "tl") return tl_err_no_invitation(inputs)
	if (locale === "vi") return vi_err_no_invitation(inputs)
	if (locale === "ko") return ko_err_no_invitation(inputs)
	if (locale === "de") return de_err_no_invitation(inputs)
	if (locale === "ru") return ru_err_no_invitation(inputs)
	if (locale === "tr") return tr_err_no_invitation(inputs)
	if (locale === "it") return it_err_no_invitation(inputs)
	if (locale === "pl") return pl_err_no_invitation(inputs)
	if (locale === "uk") return uk_err_no_invitation(inputs)
	if (locale === "hi") return hi_err_no_invitation(inputs)
	if (locale === "ar") return ar_err_no_invitation(inputs)
	if (locale === "ms") return ms_err_no_invitation(inputs)
	if (locale === "bn") return bn_err_no_invitation(inputs)
	if (locale === "zh-TW") return zh_tw2_err_no_invitation(inputs)
	if (locale === "zh-HK") return zh_hk2_err_no_invitation(inputs)
	if (locale === "ur") return ur_err_no_invitation(inputs)
	if (locale === "fa") return fa_err_no_invitation(inputs)
	if (locale === "sw") return sw_err_no_invitation(inputs)
	if (locale === "nl") return nl_err_no_invitation(inputs)
	return en_err_no_invitation(inputs)
});